import CategoryEventsSkeleton from './categoryEventsSection/categoryEventsSection.component';

export { CategoryEventsSkeleton };
